import { ErrorHandler, Injectable } from '@angular/core';
@Injectable()
export class ChunkErrorHandler implements ErrorHandler {
    handleError(error): void {
        const chunkFailedMessage = /Loading chunk [\d]+ failed/;
        if (chunkFailedMessage.test(error.message)) {
            if (confirm('New version available. Load New Version?')) {
                window.location.reload();
            }
        }
    }
}
